module.exports = __webpack_public_path__ + "static/media/29COICT5.23fc38a2.jpg";